import { ChangeDetectionStrategy, Component } from '@angular/core';

export enum Type {
  INTERCOM = 'INTERCOM',
  TYPEFORM = 'TYPEFORM',
}
@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'ws-web-apps-page',
  templateUrl: './apps.page.html',
  standalone: false,
})
export class AppsPage {
  emailEnabled = false;
  intercomEnabled = false;
  chatBotEnabled = false;
  chatBotType = Type;
  sftpEnabled = false;
  authorizeNetEnabled = false;
  lemurEnabled = false;
  lemurConfigured = false;
  bfsEnabled = false;
  bfsConfigured = false;
  // BFS owns new checkout and excludes Lemur; existing Authorize.Net gateways remain available for assigned payments.
  get bfsBlockedReason(): string | null {
    return this.lemurEnabled
      ? 'Disable Lemur financing before enabling Budco Financial Services (BFS) financing.'
      : null;
  }

  get lemurBlockedReason(): string | null {
    return this.bfsEnabled ? 'Disable Budco Financial Services (BFS) financing before enabling Lemur financing.' : null;
  }

  get authorizeNetBlockedReason(): string | null {
    return this.bfsEnabled ? 'Disable Budco Financial Services (BFS) financing before enabling Authorize.net.' : null;
  }
}
